import Request from '@/utils/request'

// ===================提现 withdrawal=================
// 获得国家信息
export function apiFetchLocationInfo () {
  return Request({
    url: '/api/v2/comm/location',
    method: 'get'
  })
}

// ===================充值 pay=================

// 获取下单支付方式
export function apiFetchPayList (params) {
  return Request({
    url: '/api/v2/app/pay/channels',
    method: 'get',
    params
  })
}

// 下单
export function apiFetchShopOrder (data) {
  return Request({
    url: '/api/v2/app/shop/order',
    method: 'post',
    data
  })
}

// ===================充值 pay for BR=================
// 获得金额列表
export function apiFetchBuyCoinsList (params) {
  return Request({
    url: '/api/v2/app/shop/5/goods',
    method: 'get',
    params
  })
}

// 获取个人信息 头像 id
export function apiFetchUserInfo (params) {
  return Request({
    url: '/api/v2/app/prop',
    method: 'get',
    params
  })
}

// ===================邀请活动 invite=================
// 获取邀请码
export function apiFetchInviteCode () {
  return Request({
    url: '/api/v2/app/agent/invited/code',
    method: 'get'
  })
}

// 邀请页面数据 tab 为 income
export function apiFetchInviteHomePage (params) {
  return Request({
    url: '/api/v2/app/agent/homepage',
    method: 'get',
    params
  })
}

// 新代理弹窗倒计时确认接口
export function apiFetchNewAgentPopup (data) {
  return Request({
    url: '/api/v2/app/agent/popup',
    method: 'post',
    data
  })
}

// My Invite 代理中心数据   //获取代理主播成员接口 tab 为 invite
export function apiFetchMyInvite (params) {
  return Request({
    url: '/api/v2/app/agent/host',
    method: 'get',
    params
  })
}

// 获得日收益 income -> Hostess Performance
export function apiFetchDailyIncome (params) {
  return Request({
    url: '/api/v2/app/agent/host/daily/income/page',
    method: 'get',
    params
  })
}

// 获得代理周收益 income -> Hostess Performance
export function apiFetchWeekIncome (params) {
  return Request({
    url: '/api/v2/app/agent/host/week/income/page',
    method: 'get',
    params
  })
}

// Hostess Earning 数据
export function apiFetchInviteHostessEarning (params) {
  return Request({
    url: '/api/v2/app/agent/host/week/income/page',
    method: 'get',
    params
  })
}

// 钱包账单接口 邀请历史-----代理收益账单传 [7,8,12]   提现记录-----[9,10,11]

// All [7, 8, 12, 19]
export function apiFetchInviteHistory (params) {
  return Request({
    url: '/api/v2/app/wallet/bill',
    method: 'get',
    params
  })
}

// ===================提现 pay=================

// 提现页面数据
export function apiWithdrawPage (walletType, withdrawalMethod = '') {
  return Request({
    url: `/api/v2/app/withdraw/wallet/${walletType}/homepage?withdrawalMethod=${withdrawalMethod}`,
    method: 'get'
  })
}

// 获取提现方式接口
export function apiWithdrawMethod (params) {
  return Request({
    url: '/api/v2/app/withdraw/method',
    method: 'get',
    params
  })
}

// 绑定提现账户
export function apiBindWithdrawAccount (data) {
  return Request({
    url: '/api/v2/app/withdraw/account/bind',
    method: 'post',
    data
  })
}

// 修改提现账户
export function apiEditWithdrawAccount (data, cfgId) {
  return Request({
    url: `/api/v2/app/withdraw/account/cfg/${cfgId}`,
    method: 'put',
    data
  })
}

// 获取用户提现账户
export function apiFetchWithdrawAccount (params) {
  return Request({
    url: '/api/v2/app/withdraw/account',
    method: 'get',
    params
  })
}

//  发送短信
export function apiFetchPhoneSms (msgType, phonePrefix, phoneNumber) {
  return Request({
    url: `/api/v2/app/sms/msg/${msgType}/phone/${phonePrefix}/${phoneNumber}`,
    method: 'get'
  })
}

// 绑定提现手机号
export function apiBindPhone (data) {
  return Request({
    url: '/api/v2/app/withdraw/phone/bind',
    method: 'post',
    data
  })
}
// 获取提现手机号
export function apiFetchPhone (params) {
  return Request({
    url: '/api/v2/app/withdraw/phone',
    method: 'get',
    params
  })
}

// 解绑提现手机号码
export function apiUnbindPhone (data) {
  return Request({
    url: '/api/v2/app/withdraw/phone/unbind',
    method: 'post',
    data
  })
}

// 申请提现
export function apiWithdrawApply (data, walletType) {
  return Request({
    url: `/api/v2/app/withdraw/wallet/${walletType}/apply`,
    method: 'post',
    data
  })
}

// 提现申请查询接口
export function apiFetchWithdrawRecord (params) {
  return Request({
    url: '/api/v2/app/withdraw/apply',
    method: 'get',
    params
  })
}

// 申请成为代理
export function apiAgentApply (data) {
  return Request({
    url: '/api/v2/app/agent/apply',
    method: 'post',
    data
  })
}

// 代理申请查询
export function apiFetchAgentApply (params) {
  return Request({
    url: '/api/v2/app/agent/apply',
    method: 'get',
    params
  })
}

// 获取用户信息
export function apiFetchUserAccountInfo (params) {
  return Request({
    url: '/api/v2/app/account/info',
    method: 'get',
    params
  })
}

// 提现之前判断是否封禁
export function apiWithdrawVerify (data, walletType) {
  return Request({
    url: `/api/v2/app/withdraw/wallet/${walletType}/apply/check`,
    method: 'post',
    data
  })
}

// 拉新主播
export function apiAcquisitionRecords (params) {
  return Request({
    url: '/api/v2/app/expand/relation/page',
    method: 'get',
    params
  })
}

// 亲密度
export function apiIntimacyDiary (uid) {
  return Request({
    url: `/api/v2/app/intimacy/relation/page/${uid}`,
    method: 'get'
  })
}

// kiss gift ranking  排行榜
export function apiGiftRanking () {
  return Request({
    url: '/api/v2/app/activity/gift/rank',
    method: 'get'
  })
}

// 代理页面新增违规数据页面
export function apiFetchVioData (params) {
  return Request({
    url: '/api/v2/app/agent/host/punish/page',
    method: 'get',
    params
  })
}

// 支付页面优惠劵列表-单参数
export function apiFetchCouponList (params) {
  return Request({
    url: '/api/v2/app/coupon',
    method: 'get',
    params
  })
}

// 支付页面优惠劵列表-多参数
export function apiFetchMutiCouponList (params) {
  return Request({
    url: '/api/v2/app/coupon/v2',
    method: 'get',
    params
  })
}

// 亲密度页面 移除亲密度 /api/v2/app/intimacy/relation/{targetUid}
export function apiDeleteBond (targetUid) {
  return Request({
    url: `/api/v2/app/intimacy/relation/${targetUid}`,
    method: 'delete'
  })
}

// my beans页面 ios 专用

// 第一张图 /api/v2/app/income/page  GET
// 第二张图 /api/v2/app/wallet/bill  GET
// 第三张图 /api/v2/app/income/week/statistics  GET
// 第四张图 /api/v2/app/income/page/2024-08-26/record GET
export function apiFetchMyBeans (params) {
  return Request({
    url: '/api/v2/app/income/page',
    method: 'get',
    params
  })
}

export function apiFetchMyBeansDetail (params) {
  return Request({
    url: '/api/v2/app/wallet/bill',
    method: 'get',
    params
  })
}

export function apiFetchReport (weekDayTime) {
  return Request({
    url: `/api/v2/app/income/week/statistics?weekDayTime=${weekDayTime}`,
    method: 'get'
  })
}

export function apiFetchReportDetail (day) {
  return Request({
    url: `/api/v2/app/income/page/${day}/record`,
    method: 'get'
  })
}

// 主播中心

// 获取主播等级页面信息 /api/v2/app/host/grade/page
export function apiFetchHostGradeInfo (params) {
  return Request({
    url: '/api/v2/app/host/grade/page',
    method: 'get',
    params
  })
}

// 获取主播违规信息
export function apiFetchPunishRecord (params) {
  return Request({
    url: '/api/v2/app/punish/record',
    method: 'get',
    params
  })
}

// 获取违规统计
export function apiFetchPunishStatistics (params) {
  return Request({
    url: '/api/v2/app/punish/statistics',
    method: 'get',
    params
  })
}

// 选择
export function apiFetchIncomeGradeList (params) {
  return Request({
    url: '/api/v2/app/host/grade/cfg',
    method: 'get',
    params
  })
}
// 选择确定
export function apiFetchChoosePrivilege (grade) {
  return Request({
    url: `/api/v2/app/host/income/grade/${grade}`,
    method: 'post'
  })
}

// 特权
export function apiFetchMatchingPrivilege (params) {
  return Request({
    url: '/api/v2/app/host/matching/privilege',
    method: 'get',
    params
  })
}

// 主播任务列表
export function apiFetchHostessTaskPage (params) {
  return Request({
    url: '/api/v2/app/task/page',
    method: 'get',
    params
  })
}

// 领取周奖励
export function apiFetchWeekTaskSubmit (week, weekTaskId) {
  return Request({
    url: `/api/v2/app/task/week/${week}/task/${weekTaskId}/submit`,
    method: 'get'
  })
}

// 领取每日任务
export function apiFetchRewardTask (taskId, conditionId) {
  return Request({
    url: `/api/v2/app/task/${taskId}/condition/${conditionId}/submit`,
    method: 'post'
  })
}

// 领取每日任务
export function apiFetchAllRewardTask (taskId) {
  return Request({
    url: `/api/v2/app/task/${taskId}/submit`,
    method: 'post'
  })
}

// 万圣节领取头像
export function apiRedeemAvatar (data) {
  return Request({
    url: '/api/v2/app/activity/gift/exchange',
    method: 'post',
    data
  })
}

// 9.9、19.19充值有额外奖励活动
export function apiRechargeActivityExtra (params) {
  return Request({
    url: '/api/v2/app/shop/7/goods',
    method: 'get',
    params
  })
}

// 巴西 葡萄牙 19.99充值活动
export function apiNineTeenNinetyNineAct (params) {
  return Request({
    url: '/api/v2/app/shop/activity/3/cfg',
    method: 'get',
    params
  })
}

//  邀请男用户去聊天活动
// GET /app/invite/page  获取邀请用户页面数据接口
// GET /app/invite/user 查询邀请用户接口
// POST /app/invite/bind/{malePresentId} 手动绑定用户

// 获取邀请用户页面数据接口
export function apiInviteBoysPage (params) {
  return Request({
    url: '/api/v2/app/invite/page',
    method: 'get',
    params
  })
}
// 查询邀请用户接口
export function apiInviteBoysIdSearch (params) {
  return Request({
    url: '/api/v2/app/invite/user',
    method: 'get',
    params
  })
}
// 手动绑定用户
export function apiInviteBoysAdd (malePresentId) {
  return Request({
    url: `/api/v2/app/invite/bind/${malePresentId}`,
    method: 'post'
  })
}

// 新年活动男用户登录领取奖励
// 进去页面弹窗数据 进页面自动签到
export function apiBoysSignReword () {
  return Request({
    url: '/api/v2/app/newyear/sign',
    method: 'post'
  })
}

// 页面数据
export function apiBoysSignData () {
  return Request({
    url: '/api/v2/app/newyear/sign/cfg',
    method: 'get'
  })
}

/**
 * @description 啤酒兑换道具列表
 */
export function apiBeerExchangeList () {
  return Request({
    url: '/api/v2/app/beer/exchange',
    method: 'get'
  })
}

/**
 * @description 啤酒兑换记录
 * @property {number} offset 第几页
 * @property {number} limit 每页个数
 */
export function apiBeerExchangeHistory (params) {
  return Request({
    url: '/api/v2/app/beer/exchange/history',
    method: 'get',
    params
  })
}

/**
 * @description 啤酒兑换道具
 */
export function apiBeerExchange (propType, propId, exchangeNum) {
  return Request({
    url: '/api/v2/app/beer/exchange',
    method: 'post',
    data: {
      propType,
      propId,
      exchangeNum
    }
  })
}

/**
 * @description 哥伦比亚银行列表
 */
export function apiGetColumbiaBankList () {
  return Request({
    url: '/api/v2/app/withdraw/1/bank/cfg',
    method: 'post',
    data: {}
  })
}

/**
  * @description 亲密度（新）
 */
export function apiIntimacyFriendship (targetUid) {
  return Request({
    url: `/api/v2/app/friend/relation/page/${targetUid}`,
    method: 'get'
  })
}

/**
  * @description 获取权益/送礼物（新）
 */
export function apiFriendshipGetAndSend (targetUid, grade, data) {
  return Request({
    url: `/api/v2/app/friend/claim/benefit/${targetUid}/${grade}`,
    method: 'post',
    data
  })
}

/**
 * @description 删除亲密（新）
 */
export function apiDeleteFriendship (targetUid) {
  return Request({
    url: `/api/v2/app/friend/delete/${targetUid}`,
    method: 'post'
  })
}

/**
 * @description 签到-列表
 */
export function apiSigninList () {
  return Request({
    url: '/api/v2/app/sign/host/first7day/mainPage',
    method: 'get'
  })
}

/**
 * @description 签到-提交签到
 */
export function apiSubmitSignin () {
  return Request({
    url: '/api/v2/app/sign/host/first7day/sign',
    method: 'post'
  })
}

/**
 * @description 提现自动打款审核结果
 */
export function apiWithdrawAutoCheckResult () {
  return Request({
    url: '/api/v2/app/withdraw/instant/pay/pre/check',
    method: 'post'
  })
}

/**
 * @description 提现打款状态
 */
export function apiGetWithdrawStatus (withdrawId) {
  return Request({
    url: `/api/v2/app/withdraw/apply/${withdrawId}`,
    method: 'get'
  })
}

export function getAwsInfoApi () {
  return Request({
    url: `/api/v2/comm/aws/key`,
    method: 'get'
  })
}

/**
 * @description 获取动态policy接口
 */
export function apiGetDyPolicyApi (languageParam) {
  return Request({
    url: `/api/v2/app/agent/policy?languageParam=${languageParam}`,
    method: 'get'
  })
}

/**
 * @description 获取动态policy 预览接口
 */
export function apiGetDyPolicyPreviewApi (languageParam) {
  return Request({
    url: `/api/v2/app/agent/policy/preview?languageParam=${languageParam}`,
    method: 'get'
  })
}

/**
 * @description 主播排行榜-领取
 */
export function apiGetHostessRankApi (params) {
  return Request({
    url: `/api/v2/app/rank/onDemand/rankPage`,
    method: 'get',
    params
  })
}

/**
 * @description 主播排行榜-配置
 */
export function apiGetHostessRankCfgApi () {
  return Request({
    url: `/api/v2/app/rank/onDemand/rewardCfg`,
    method: 'get'
  })
}

/**
 * @description 主播排行榜-领取
 */
export function apiGetHostessRankGetApi () {
  return Request({
    url: `/api/v2/app/rank/onDemand/getReward`,
    method: 'get'
  })
}

export function getPackageNamePayBack (params) {
  return Request({
    url: `/api/v2/app/pay/redirect`,
    method: 'get',
    params
  })
}